import { gql } from 'graphql-request'

export const GET_BOOKMARK_LIST = gql`
  query GetBookmarkList(
    $limitPerPage: Int
    $page: Int
    $bookType: [BookType!]
    $categoryIds: [Int!]
    $searchText: String
    $sort: String
  ) {
    getBookmarksByUser(
      limitPerPage: $limitPerPage
      page: $page
      bookType: $bookType
      categoryIds: $categoryIds
      searchText: $searchText
      sort: $sort
    ) {
      data {
        id
        createdAt
        bookChapter {
          id
          chapterName
          book {
            id
            coverImgPath
            coverResizeImgPath
            title
            penName {
              user {
                id
                profilePageSlug
              }
              firstPenName
            }
          }
        }
      }
      total
    }
  }
`
